import { Module } from "vuex-module-decorators";

import PageModule from "@/core/base/PageModule";
import Filter from "./models/filter";

@Module({ namespaced: true })
export default class Budget extends PageModule {
  override endPoint = "FinancialClosure";
  override indexUrl = "/Budget";
  override filter = new Filter();
}
